import Vue from 'vue';
import {extend, localize, ValidationObserver, ValidationProvider} from 'vee-validate';
import {alpha, alpha_spaces, email, max, min, numeric, required} from 'vee-validate/dist/rules';

// Importa i messaggi in italiano
import it from 'vee-validate/dist/locale/it.json';

// Registra i messaggi in italiano
localize('it', it);

// Registrazione dei validatori comuni
extend('required', {
  ...required,
  message: 'Il campo è obbligatorio.'
});

extend('email', {
  ...email,
  message: 'Il campo deve essere un indirizzo email valido.'
});

extend('min', {
  ...min,
  message: 'Il campo deve essere di almeno {length} caratteri.'
});

extend('max', {
  ...max,
  message: 'Il campo deve essere di massimo {length} caratteri.'
});

extend('numeric', {
  ...numeric,
  message: 'Il campo deve essere numerico.'
});

extend('alpha', {
  ...alpha,
  message: 'Il campo deve contenere solo lettere.'
});

extend('alpha_spaces', {
  ...alpha_spaces,
  message: 'Il campo deve contenere solo lettere e spazi.'
});

// Registrazione del validatore per le date in italiano
extend('date_it', {
    validate(value) {
        // Logica di validazione per le date in italiano
        const regex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
        if (!regex.test(value)) {
            return false;
        }

        const [day, month, year] = value.split('/');
        const date = new Date(`${year}-${month}-${day}`);

        return date instanceof Date && !isNaN(date);
    },
    message: 'Inserisci una data valida nel formato gg/mm/aaaa.',
});

// Impostazione della lingua italiana come lingua predefinita per i messaggi di validazione
localize('it');
localize({
    messages: {
        required: 'Questo campo è obbligatorio.',
    },
});

// Configurazione globale di VeeValidate in Vue
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// Impostazione della lingua predefinita per i messaggi di validazione
